import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/shared/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-view-attendance',
  templateUrl: './view-attendance.component.html',
  styleUrls: ['./view-attendance.component.scss', '../../../../../../assets/sass/pages/page-users.scss'],
})
export class ViewAttendanceComponent implements OnInit {

  attendanceId:any;
  attendanceData:any
  imageUrl=environment.apiUrls.imageUrl;

  constructor(public apiService:ApiService,private activatedroute:ActivatedRoute){
    this.activatedroute.paramMap.subscribe(params => { 
    this.attendanceId = params.get('id'); 
    console.log('attendanceId',this.attendanceId)
  });
}

  ngOnInit(): void {
    this.getAttendanceById()
  }
  getAttendanceById(){
    this.apiService.getAttendanceById(this.attendanceId).subscribe((res:any)=>{
      console.log(res)
      this.attendanceData=res.data
    })
  }
}

